export const getIsLoadFirstWindow = state => state.isOpenFirst
export const getIsOpenWindowCart = state => state.isOpenDeleteFromCart
export const getIsFormOpen = state => state.isFormOpen
export const vendor = state => state.vendorCode
export const getCards = state => state.cards

export const getComent = state => state.values
export const getSurname = state => state.values.surname
export const getAge = state => state.values.age
export const getDelivery = state => state.values.delivery
export const getMobil = state => state.values.mobil
export const getMessage = state => state.message



